import React from 'react';
import { Route, Routes } from 'react-router-dom';
import ListUserReports from './list-user-reports';
import UserReportDetail from './user-report-detail';
import Header from '../common/components/header';
import Sidebar from '../common/components/sidebar';

const UserReportRoutes = () => (
  <>
    <Header />
    <Sidebar />
    <div className="page-wrapper">
      <div className="content">
        <Routes>
          <Route path="/list-user-reports" element={<ListUserReports />} />
          <Route path="/user-report-detail/:id" element={<UserReportDetail />} />
          <Route path="/" element={<ListUserReports />} />
        </Routes>
      </div>
    </div>
  </>
);

export default UserReportRoutes; 